var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7068 0.293031L19.7068 9.29303C20.3368 9.92303 19.8908 11 18.9998 11H17.9998V17C17.9998 17.7957 17.6837 18.5587 17.1211 19.1214C16.5585 19.684 15.7954 20 14.9998 20H13.9998V13C13.9998 12.2348 13.7075 11.4985 13.1825 10.9418C12.6576 10.385 11.9397 10.0499 11.1758 10.005L10.9998 10H8.99979C8.20415 10 7.44108 10.3161 6.87847 10.8787C6.31587 11.4413 5.99979 12.2044 5.99979 13V20H4.99979C4.20415 20 3.44108 19.684 2.87847 19.1214C2.31587 18.5587 1.99979 17.7957 1.99979 17V11H0.999795C0.109795 11 -0.337205 9.92303 0.292795 9.29303L9.2928 0.293031C9.48032 0.105559 9.73463 0.000244141 9.99979 0.000244141C10.265 0.000244141 10.5193 0.105559 10.7068 0.293031ZM10.9998 12C11.265 12 11.5194 12.1054 11.7069 12.2929C11.8944 12.4805 11.9998 12.7348 11.9998 13V20H7.99979V13C7.99983 12.7551 8.08975 12.5187 8.25251 12.3357C8.41527 12.1526 8.63954 12.0357 8.8828 12.007L8.99979 12H10.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7cd797eba9f814326b3ecab258e0b2cf.svg";
export { ForwardRef as ReactComponent };